import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import type { User } from '../../api/types';
import { useToast } from '../../components/Toast';
import { todayISO } from '../../utils/time';
import { AsyncButton } from '../../components/AsyncButton';

function fmtDT(s: string) {
  return new Intl.DateTimeFormat('it-IT', { dateStyle:'short', timeStyle:'short' }).format(new Date(s));
}

export function AdminLoginsPage() {
  const { push } = useToast();
  const [users, setUsers] = useState<User[]>([]);
  const [userId, setUserId] = useState<string>('');
  const [from, setFrom] = useState(() => {
    const d = new Date();
    d.setDate(1);
    return d.toISOString().slice(0,10);
  });
  const [to, setTo] = useState(() => todayISO());
  const [items, setItems] = useState<any[]>([]);

  async function loadUsers() {
    const r = await api.get<{users: User[]}>('/api/admin/users');
    setUsers(r.users);
    if (!userId && r.users[0]) setUserId(r.users[0]._id);
  }

  async function load() {
    try {
      const qs = new URLSearchParams();
      if (userId) qs.set('userId', userId);
      qs.set('from', from);
      qs.set('to', to);
      const r = await api.get<{items:any[]}>(`/api/admin/login-events?${qs.toString()}`);
      setItems(r.items);
    } catch (e:any) {
      push({ title: 'Errore', body: e?.message });
    }
  }

  useEffect(() => { loadUsers(); }, []);
  useEffect(() => { if (userId) load(); }, [userId]);

  return (
    <div className="grid" style={{ gap: 16 }}>
      <div className="card">
        <div className="h2" style={{ marginTop:0 }}>Eventi Login</div>

        <div className="grid" style={{ gridTemplateColumns:'1fr 1fr 1fr', gap: 10 }}>
          <div>
            <div className="small">Dipendente</div>
            <select className="input" value={userId} onChange={(e) => setUserId(e.target.value)}>
              {users.map(u => <option key={u._id} value={u._id}>{u.first_name} {u.last_name}</option>)}
            </select>
          </div>
          <div>
            <div className="small">Da</div>
            <input className="input" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          </div>
          <div>
            <div className="small">A</div>
            <input className="input" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
        </div>

        <AsyncButton className="btn btnPrimary" style={{ marginTop: 12 }} onClickAsync={load} busyText="Carico…">Cerca</AsyncButton>
      </div>

      <div className="card" style={{ padding: 0, overflow:'hidden' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'var(--black)', color:'var(--white)' }}>
                <th style={{ padding: 12, textAlign:'left' }}>Quando</th>
                <th style={{ padding: 12, textAlign:'left' }}>IP</th>
                <th style={{ padding: 12, textAlign:'left' }}>User Agent</th>
                <th style={{ padding: 12, textAlign:'left' }}>Posizione</th>
              </tr>
            </thead>
            <tbody>
              {items.map((e, idx) => (
                <tr key={e._id} style={{ background: idx % 2 ? 'rgba(255,255,255,.02)' : 'rgba(255,255,255,.04)' }}>
                  <td style={{ padding: 12 }}>{fmtDT(e.login_at)}</td>
                  <td style={{ padding: 12 }}>{e.ip || '—'}</td>
                  <td style={{ padding: 12, maxWidth: 360, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{e.user_agent || '—'}</td>
                  <td style={{ padding: 12 }}>{e.location?.address || (e.location ? `${e.location.lat?.toFixed?.(4)}, ${e.location.lon?.toFixed?.(4)}` : '—')}</td>
                </tr>
              ))}
              {items.length === 0 ? <tr><td colSpan={4} className="small" style={{ padding: 16 }}>Nessun evento.</td></tr> : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
